// ─────────────────────────────────────────────
//  AgreezAgro — Shared Site Data
//  Edit this file to update all content
// ─────────────────────────────────────────────

export const brand = {
  name: "AgreezAgro",
  tagline: "Science. Protection. Yield.",
  email: "info@agreezagro.in",
  phone: "+91 9111124400",
  address: "BO-20, UPSIDC, GOPALPUR INDUSTRIAL AREA SIKANDRABAD (UP) 203205",
  social: {
    twitter: "#",
    facebook:
      "https://www.facebook.com/profile.php?id=100094450271928&mibextid=LQQJ4d",
    linkedin: "#",
    youtube: "#",
  },
};

export const navLinks = [
  { label: "Products", href: "#products" },
  { label: "Solutions", href: "#solutions" },
  { label: "Science", href: "#science" },
  { label: "Crops", href: "#crops" },
  { label: "About Us", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const hero = {
  eyebrow: "Advanced Crop Protection",
  heading: ["Defend Every", "Acre.", "Amplify Every", "Harvest."],
  description:
    "Industry-leading pesticides, herbicides, and fungicides engineered for precision agriculture. Scientifically formulated. Environmentally responsible. Proven results across 60+ crops.",
  stats: [
    { num: "60+", label: "Crops Protected" },
    { num: "98.7%", label: "Efficacy Rate" },
    { num: "12+", label: "States Covered" },
    { num: "10yr", label: "R&D Heritage" },
  ],
  badges: [
    {
      icon: "🌿",
      title: "Herbicides",
      sub: "12 formulations",
      color: "#2D6A35",
    },
    {
      icon: "🍄",
      title: "Fungicides",
      sub: "14 formulations",
      color: "#7850B4",
    },
    {
      icon: "🐛",
      title: "Insecticide",
      sub: "15 formulations",
      color: "#C0392B",
    },
    { icon: "🌱", title: "PGR", sub: "12 formulations", color: "#0288D1" },
  ],
};

export const productCategories = [
  {
    id: "herbicide",
    icon: "🌿",
    color: "#2E7D32",
    colorLight: "rgba(46,125,50,0.12)",
    label: "HERBICIDES",
    heading: "Weed-Free. Worry-Free.",
    desc: "Pre-emergent and post-emergent herbicide solutions that eliminate competitive weeds while leaving your target crop unharmed.",
    products: [
      {
        name: "AGREEZ 71",
        type: "Post-Emergent Broadleaf",
        active: "AMMONIUM SALT OF GLYPHOSATE 71% SG",
        crops: "TEA & NON CROPS",
        pack: "100GM",
        image: "/Products/new/HERBICIDE/agreez-71.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: "Best Seller",
        details: [
          "Selective broadleaf weed control",
          "Fast translocation within plant",
          "Cost-effective per-acre treatment",
          "Compatible with most tank mixes",
        ],
        dosage: "1.2KG per acre",
      },
      {
        name: "GLISHELL-41",
        type: "Post-Emergent Broadleaf",
        active: "Glyphosate 41% SL",
        crops: "TEA",
        pack: "1Ltr, 500ml",
        image: "/Products/new/HERBICIDE/glishell-41.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: "Best Seller",
        details: [
          "Selective broadleaf weed control",
          "Fast translocation within plant",
          "Cost-effective per-acre treatment",
          "Compatible with most tank mixes",
        ],
        dosage: "800-1200 ml per acre",
      },
      {
        name: "OXY PRO",
        type: "Post-Emergent Broadleaf",
        active: "OXYFLOURFEN 23.5% EC",
        crops: "Onion, Tea, Potato, Groundnut, Mentha",
        pack: "100ml",
        image: "/Products/new/HERBICIDE/oxy-pro.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: "Best Seller",
        details: [
          "Selective broadleaf weed control",
          "Fast translocation within plant",
          "Cost-effective per-acre treatment",
          "Compatible with most tank mixes",
        ],
        dosage: "170-360 ml per acre",
      },
      {
        name: "AGRI SWIFT SUPER",
        type: "Non-Selective",
        active: "PRETILACHLOR 37% EW",
        crops: "Paddy",
        pack: "3LTR, 1200ML, 600ML",
        image: "/Products/new/HERBICIDE/agri-swift-super.png",
        emoji: "🧪",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Eliminates all vegetation types",
          "Soil-inactivated — safe to replant",
          "Ideal for land clearing",
          "Translocates to roots for complete kill",
        ],
        dosage: "600-750 ML per acre",
      },
      {
        name: "AGRI SWIFT",
        type: "Selective Grass Killer",
        active: "PRETILACHLOR 50% EC",
        crops: "TRANSPLANTED PADDY",
        pack: "5LTR, 1 LTR, 500ML, 250ML",
        image: "/Products/new/HERBICIDE/agri-swift.png",
        emoji: "🌿",
        color: "#F3E5F5",
        badge: "New",
        details: [
          "Targets only grassy weeds",
          "Zero injury to broadleaf crops",
          "Absorbed via leaf & translocated",
          "Effective on resistant ryegrass",
        ],
        dosage: "400-600 ML per acre (PRE-EMERGENCE)",
      },
      {
        name: "AMINE-58",
        type: "Pre-Emergent",
        active: "2,4-D AMINE SALT 58% SL",
        crops: "Corn, Sugarcane, Wheat",
        pack: "1LTR, 400ML, 250ML",
        image: "/Products/new/HERBICIDE/amine-58.png",
        emoji: "🛡️",
        color: "#E0F7FA",
        badge: null,
        details: [
          "Stops weed seed germination",
          "8–10 week residual activity",
          "Reduces early crop competition",
          "Apply before weed emergence",
        ],
        dosage: "400-1200 ML per acre",
      },
      {
        name: "DAMINI GOLD",
        type: "Post-Emergent Paddy",
        active: "BISPYRIBAC SODIUM 10% SC",
        crops: "PADDY",
        pack: "1 LTR, 100ML, 50ML",
        image: "/Products/new/HERBICIDE/damini-gold.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls complex weed flora in paddy",
          "Highly selective — zero crop injury",
          "Controls sedges, grasses & broadleafs",
          "Single spray solution",
        ],
        dosage: "100ML per acre",
      },
      {
        name: "AGRIGIL",
        type: "Post-Emergent Broadleaf",
        active: "Propaquizafop 10% EC",
        crops: "Soybean, Black Gram, Onion",
        pack: "5Ltr, 1Ltr, 500ml",
        image: "/Products/new/HERBICIDE/agrigil.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls complex weed flora",
          "Highly selective — zero crop injury",
          "Controls sedges, grasses & broadleafs",
          "Single spray solution",
        ],
        dosage: "200-400 ml per acre",
      },
      {
        name: "QUICK SUPER",
        type: "Post-Emergent Grass",
        active: "QUIZALOFOP ETHYL 10% EC",
        crops: "Soybean, Sunflower",
        pack: "1 LTR, 500ML, 100ML",
        image: "/Products/new/HERBICIDE/quick-super.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls complex weed flora",
          "Highly selective — zero crop injury",
          "Controls sedges, grasses & broadleafs",
          "Single spray solution",
        ],
        dosage: "300-350 ml per acre",
      },
      {
        name: "VASHIRA",
        type: "Post-Emergent Broadleaf",
        active: "Imazerthapyr 10% SL",
        crops: "Soybean, Groundnut",
        pack: "1Kg, 500gm, 250gm",
        image: "/Products/new/HERBICIDE/vashira.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls complex weed flora",
          "Highly selective — zero crop injury",
          "Controls sedges, grasses & broadleafs",
          "Single spray solution",
        ],
        dosage: "300 ml per acre",
      },
      {
        name: "AGRI POWER",
        type: "Non-Selective Contact",
        active: "Glufosinate Ammonium 13.5% w/w SL (15% w/v)",
        crops: "Cotton, Tea",
        pack: "5Ltr, 1Ltr, 500ml, 250ml",
        image: "/Products/new/HERBICIDE/agri-power.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Broad spectrum contact action",
          "Fast-acting non-selective herbicide",
          "Controls grasses and broadleaf weeds",
          "Suitable for orchards and non-crop areas",
        ],
        dosage: "2.5-3.0 ml per acre",
      },
      {
        name: "AGRIQUAT",
        type: "Post-Emergent Non-Selective",
        active: "PARAQUAT DICHLORIDE 24% SL",
        crops: "Cotton, Potato, Rubber, Grapes, Paddy, Wheat",
        pack: "1 LTR, 500 ML",
        image: "/Products/new/HERBICIDE/agriquat.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls all vegetation types",
          "Soil-inactivated on contact",
          "Ideal for pre-sowing land clearing",
          "Translocates to roots for complete kill",
        ],
        dosage: "500-1000 ml per acre",
      },
      {
        name: "HEER 44",
        type: "Broadleaf + Grass",
        active: "2,4-D ETHYL ESTER 38% EC",
        crops: "Potato, Tomato, Soybean, Sorghum, Maize, Wheat, Paddy",
        pack: "1 LTR, 500ML, 250ML",
        image: "/Products/new/HERBICIDE/heer-44.png",
        emoji: "🥔",
        color: "#FBE9E7",
        badge: null,
        details: [
          "Dual pre & post-emergent action",
          "Effective on 25+ weed species",
          "Low dose — high efficacy",
          "Wettable powder — easy mixing",
        ],
        dosage: "0.45-1.0 ML per acre",
      },
      {
        name: "AGRI-9",
        type: "Broadleaf + Narrow Leaf",
        active: "CLODINAFOP PROPAGYL 9%+METRIBUZIN 20% WP",
        crops: "Wheat",
        pack: "240GM",
        image: "/Products/new/HERBICIDE/agri-9.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: null,
        details: [
          "Controls broad and narrow leaf weeds",
          "Dual mode of action",
          "Effective at low doses",
          "Excellent crop safety",
        ],
        dosage: "240GM per acre",
      },
      {
        name: "AGRIP",
        type: "Selective Broadleaf",
        active: "Metsulfuron Methyl 20% WP",
        crops: "Wheat, Paddy, Sugarcane",
        pack: "8GM",
        image: "/Products/new/HERBICIDE/agrip.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: null,
        details: [
          "Broadleaf weed control",
          "High potency low-dose formulation",
          "Controls sedges in paddy",
          "Residual soil activity",
        ],
        dosage: "8GM per acre",
      },
      {
        name: "AGREEZ MET-70",
        type: "Pre & Post-Emergent",
        active: "METRIBUZIN 70% WP",
        crops: "Soybean, Tomato, Wheat, Potato, Sugarcane",
        pack: "100GM, 50GM",
        image: "/Products/new/HERBICIDE/agreez-met-70.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls annual grasses and broadleaf weeds",
          "Pre and post-emergent activity",
          "Compatible with most herbicides",
          "Long residual control",
        ],
        dosage: "100-300 GM per acre",
      },
      {
        name: "STOP EXTRA",
        type: "Pre-Emergent",
        active: "PENDIMETHALIN 30% EC",
        crops: "Wheat, Paddy, Soybean, Cotton, Chilli, Groundnut",
        pack: "1 LTR, 500ML",
        image: "/Products/new/HERBICIDE/stop-extra.png",
        emoji: "🛡️",
        color: "#E0F7FA",
        badge: null,
        details: [
          "Pre-emergent grass and broadleaf control",
          "Long lasting soil residual",
          "Prevents weed emergence",
          "Apply before crop germination",
        ],
        dosage: "1000-1200 ML per acre",
      },
      {
        name: "TAMBOO",
        type: "Selective Grass",
        active: "TEMBOTRIONE 34.4% SC",
        crops: "Maize",
        pack: "230ml, 115ml, 57.5ml",
        image: "/Products/new/HERBICIDE/tamboo.png",
        emoji: "🌽",
        color: "#FFF3E0",
        badge: "New",
        details: [
          "Post-emergent grass weed control in maize",
          "Effective on Echinochloa and Brachiaria",
          "Rainfast within 1 hour",
          "High selectivity for maize",
        ],
        dosage: "115ML per acre",
      },
      {
        name: "SARTHI",
        type: "Selective Paddy",
        active: "PYRAZOSULFURON ETHYL 10% WP",
        crops: "Paddy",
        pack: "80GM, 20GM",
        image: "/Products/new/HERBICIDE/sarthi.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Post-emergent weed control in paddy",
          "Controls annual grassy and broadleaf weeds",
          "Highly selective to transplanted paddy",
          "Single application effective",
        ],
        dosage: "80GM per acre",
      },
      {
        name: "CLEAR",
        type: "Selective Wheat",
        active: "SULFOSULFURON 75% WG",
        crops: "Wheat, Apple, Chilli",
        pack: "13.5GM",
        image: "/Products/new/HERBICIDE/clear.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: null,
        details: [
          "Controls Phalaris minor in wheat",
          "Broad spectrum weed control",
          "Low dose — high efficacy",
          "Compatible with most fertilisers",
        ],
        dosage: "13.5GM per acre",
      },
      {
        name: "CLOUDY",
        type: "Selective Wheat",
        active: "CLODINAFOP PROPARGYL 15% WP",
        crops: "Wheat",
        pack: "160GM",
        image: "/Products/new/HERBICIDE/cloudy.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: null,
        details: [
          "Controls Gulli Danda (Phalaris Minor)",
          "Post-emergent grass control",
          "Highly selective for wheat",
          "Fast-acting translocation",
        ],
        dosage: "160GM per acre",
      },
      {
        name: "ATRA-50",
        type: "Pre-Emergent Grass",
        active: "ATRAZINE 50% WP",
        crops: "Maize, Groundnut",
        pack: "500GM",
        image: "/Products/new/HERBICIDE/atra-50.png",
        emoji: "🌽",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls annual grasses and broadleafs",
          "Pre-emergent soil application",
          "Long residual activity",
          "Economical broad-spectrum control",
        ],
        dosage: "400-800 GM per acre",
      },
      {
        name: "JAKIRA",
        type: "Selective Grass",
        active: "PYROXASULFONE 85% WG",
        crops: "Maize, Wheat",
        pack: "120GM, 60GM",
        image: "/Products/new/HERBICIDE/jakira.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: "New",
        details: [
          "Controls Echinochloa and narrow leaf weeds",
          "Pre-emergent application",
          "Low dose high efficacy",
          "Excellent crop safety",
        ],
        dosage: "60-150 GM per acre",
      },
      {
        name: "MESSAGE",
        type: "Broadleaf + Grass",
        active: "CLODINAFOP PROPARGYL 15% + METSULFURON METHYL 1% WP",
        crops: "Wheat",
        pack: "160GM",
        image: "/Products/new/HERBICIDE/message.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: null,
        details: [
          "Dual-action broadleaf and grass control",
          "Controls Phalaris minor and broadleaf weeds",
          "Single application solution",
          "Low dose — excellent safety",
        ],
        dosage: "160GM per acre",
      },
      {
        name: "AGRISAL",
        type: "Selective Grass",
        active: "PINOXADEN 5.1% SL",
        crops: "Wheat",
        pack: "2LTR, 400ML",
        image: "/Products/new/HERBICIDE/agrisal.png",
        emoji: "🌾",
        color: "#F9FBE7",
        badge: null,
        details: [
          "Controls Phalaris minor (Canary grass)",
          "Post-emergent selective herbicide",
          "Excellent crop safety for wheat",
          "Translocated to growing points",
        ],
        dosage: "320-360ML per acre",
      },
      {
        name: "AGRIMAX",
        type: "Transplanted Rice",
        active: "METSULFURON METHYL 10% + CHLORIMURON ETHYL 10% WP",
        crops: "Transplanted Rice",
        pack: "8GM",
        image: "/Products/new/HERBICIDE/agrimax.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Pre-emergence application (3 DAT)",
          "Controls sedges and aquatic weeds",
          "Single application solution",
          "Highly selective for transplanted rice",
        ],
        dosage: "8GM per acre",
      },
      {
        name: "AGRISTAR",
        type: "Selective Grass + Sedge",
        active: "OXADIARGYL 80% W.P.",
        crops: "Sunflower, Transplanted Rice, Cabbage",
        pack: "50GM",
        image: "/Products/new/HERBICIDE/agristar.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls Echinochloa and Cyperus",
          "Effective on sedges and grasses",
          "Pre-emergent application",
          "Broad spectrum weed control",
        ],
        dosage: "50GM per acre",
      },
      {
        name: "AGRIZONE",
        type: "Post-Emergent Maize",
        active: "TOPRAMEZONE 336 G/L",
        crops: "Maize",
        pack: "75ML, 30ML",
        image: "/Products/new/HERBICIDE/agrizone.png",
        emoji: "🌽",
        color: "#FFF3E0",
        badge: "New",
        details: [
          "Controls Elusine indica and Digitaria",
          "Post-emergent application",
          "MSO adjuvant recommended",
          "Selective for maize crop",
        ],
        dosage: "25.2-33.6 g a/ha per acre",
      },
      {
        name: "BLADE",
        type: "Soybean Weed",
        active: "LIQUID SODIUM ACIFLUORTEN 16.5% + CLODINAFOP PROPARGYL 8% EC",
        crops: "Soybean",
        pack: "1Ltr, 400ml, 200ml",
        image: "/Products/new/HERBICIDE/blade.png",
        emoji: "🫘",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls a wide spectrum of soybean weeds",
          "Dual-action formulation",
          "Effective on Acalypha indica and Celosia",
          "Post-emergent application",
        ],
        dosage: "150-200 Ltr per acre",
      },
      {
        name: "STRONG",
        type: "Selective Groundnut",
        active: "DICLOSULAM 84% WG",
        crops: "Groundnut",
        pack: "100GM, 12.4GM",
        image: "/Products/new/HERBICIDE/strong.png",
        emoji: "🥜",
        color: "#FFF8E1",
        badge: null,
        details: [
          "Controls Amaranthus and Parthenium weeds",
          "Pre-emergent soil application",
          "Selective for groundnut",
          "Controls Cyperus species",
        ],
        dosage: "12.4 GM per acre",
      },
      {
        name: "KOLARAS",
        type: "Post-Emergent Grass",
        active: "MESOTRIONE 2.27% + ATRAZINE 22.7% SC",
        crops: "Maize, Sugarcane",
        pack: "1400ML, 700ML",
        image: "/Products/new/HERBICIDE/kolaras.png",
        emoji: "🌽",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Post-emergent broadleaf and grass control",
          "Dual active ingredient formulation",
          "Effective on Trianthema and Digitaria",
          "Excellent selectivity for maize",
        ],
        dosage: "1400ML per acre",
      },
    ],
  },
  {
    id: "fungicide",
    icon: "🍄",
    color: "#5C35A8",
    colorLight: "rgba(92,53,168,0.12)",
    label: "FUNGICIDES",
    heading: "Stop Fungal Threats Early.",
    desc: "Systemic and contact fungicides that protect crops against a full spectrum of fungal pathogens — from seed treatment to harvest.",
    products: [
      {
        name: "CUMIN-80",
        type: "Sulphur Fungicide",
        active: "SULPHUR 80% WDG",
        crops: "Grapes, Apple, Cowpea, Cumin, Mango, Pea, Guar",
        pack: "5 KG, 3KG, 1 KG",
        image: "/Products/new/FUNGICIDE/cumin-80.png",
        emoji: "🍇",
        color: "#EDE7F6",
        badge: "Best Seller",
        details: [
          "Controls rust, smut & powdery mildew",
          "Curative & preventive action",
          "Excellent rainfastness",
          "Proven on 30+ fungal species",
        ],
        dosage: "750-1000 GM per acre",
      },
      {
        name: "HEXA TOP",
        type: "Systemic Triazole",
        active: "HEXACONAZOLE 5% SC",
        crops: "Paddy, Mango",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/FUNGICIDE/hexa-top.png",
        emoji: "🍅",
        color: "#FBE9E7",
        badge: null,
        details: [
          "Systemic triazole fungicide",
          "Controls sheath blight in paddy",
          "Effective on powdery mildew of mango",
          "Excellent rainfastness after 1hr",
        ],
        dosage: "250-400 ml per acre",
      },
      {
        name: "METALIX",
        type: "Combination Fungicide",
        active: "METALAXYL 8%+MANCOZEB 64% WP",
        crops: "Grapes, Papaya, Apple & Potato",
        pack: "500GM, 250GM, 100GM, 50GM",
        image: "/Products/new/FUNGICIDE/metalix.png",
        emoji: "🌱",
        color: "#E8F5E9",
        badge: "Organic",
        details: [
          "Colonises roots & suppresses pathogens",
          "Controls downy mildew & late blight",
          "Zero MRL concerns",
          "Compatible with IPM programs",
        ],
        dosage: "700-1000 GM per acre",
      },
      {
        name: "SURETY",
        type: "Combination Fungicide",
        active: "CARBENDAZIM 12% + MANCOZEB 63% WP",
        crops: "Groundnut, Paddy, Potato, Tea",
        pack: "1Kg, 500gm, 250gm, 100gm, 50gm",
        image: "/Products/new/FUNGICIDE/surety.png",
        emoji: "🍎",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Broad spectrum fungicidal & bactericidal",
          "Prevents canker & downy mildew",
          "Affordable protective spray",
          "Compatible with most pesticides",
        ],
        dosage: "250-750 GM per acre",
      },
      {
        name: "TARRANO",
        type: "Systemic DMI",
        active: "THIOPHANATE METHYL 70% WP",
        crops: "Grapes, Papaya & Apple, Bottle Gourd, Paddy",
        pack: "500GM, 250GM, 100GM",
        image: "/Products/new/FUNGICIDE/tarrano.png",
        emoji: "☕",
        color: "#F3E5F5",
        badge: "New",
        details: [
          "Controls sheath blight in rice",
          "Excellent systemic uptake",
          "Long-lasting protective cover",
          "Low dose — high efficacy",
        ],
        dosage: "1-1.25GM PER LTR WATER",
      },
      {
        name: "TESLA",
        type: "Seed Treatment Fungicide",
        active: "TEBUCONAZOLE 10%+SULPHUR 65% WG",
        crops: "Chilli, Mango",
        pack: "1KG, 500GM, 250GM, 100GM",
        image: "/Products/new/FUNGICIDE/tesla.png",
        emoji: "🌻",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Protects seed from soil-borne fungi",
          "Controls powdery mildew and fruit rot",
          "Easy slurry coating application",
          "Controls damping-off & seed rot",
        ],
        dosage: "1.25GM PER GM WATER",
      },
      {
        name: "SHINE STAR TOP",
        type: "Combination Fungicide",
        active: "AZOXYSTROBIN 18.2% + DIFENOCONAZOLE 11.4% SC",
        crops: "Maize, Chilli, Paddy",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML, 20ML",
        image: "/Products/new/FUNGICIDE/shine-star-top.png",
        emoji: "🌻",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Protects from powdery mildew and blast",
          "Improves germination rate",
          "Curative and preventive action",
          "Controls blight in paddy",
        ],
        dosage: "200ML per acre",
      },
      {
        name: "AGREEZ M-45",
        type: "Contact Fungicide",
        active: "MANCOZEB 75% WP",
        crops:
          "Apple, Chilli, Wheat, Paddy, Soybean, Potato, Grapes, Groundnut",
        pack: "1KG, 500GM",
        image: "/Products/new/FUNGICIDE/agreez-m-45.png",
        emoji: "🍎",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Broad spectrum contact fungicide",
          "Controls scab, sooty blotch, rust & blight",
          "Excellent tank-mix partner",
          "Multi-site mode of action",
        ],
        dosage: "600-800 GM per acre",
      },
      {
        name: "SHINE STAR",
        type: "Combination Fungicide",
        active: "AZOXYSTROBIN 11% + TEBUCONAZOLE 18.3% SC",
        crops: "Wheat, Tomato, Grapes, Apple",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML, 20ML",
        image: "/Products/new/FUNGICIDE/shine-star.png",
        emoji: "🌟",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Controls diaback and fruit rot",
          "Curative and preventive action",
          "Controls powdery mildew & sheath blight",
          "Excellent rainfastness",
        ],
        dosage: "240-300 ml per acre",
      },
      {
        name: "TOORA",
        type: "Combination Fungicide",
        active: "TEBUCONAZOLE 6.7%+CAPTAN 26.9% W/W SC",
        crops: "Apple, Chilli",
        pack: "1 Ltr, 500ml, 250ml",
        image: "/Products/new/FUNGICIDE/toora.png",
        emoji: "🍎",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls powdery mildew and Alternaria",
          "Curative and preventive dual action",
          "Excellent systemic uptake",
          "Controls anthracnose in chilli",
        ],
        dosage: "400-600 ml per acre",
      },
      {
        name: "VENTO SUPER",
        type: "Combination Fungicide",
        active: "AZOXYSTROBIN 20%+THIFLUZAMIDE 15% W/W",
        crops: "Paddy, Vegetable, Fruits, Pulses",
        pack: "1Ltr, 500ml, 250ml",
        image: "/Products/new/FUNGICIDE/vento-super.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: "New",
        details: [
          "Controls anthracnose, leaf spots, powdery mildew & rust",
          "Broad spectrum activity",
          "Excellent rainfastness after 1 hr",
          "Compatible with most pesticides",
        ],
        dosage: "200-250 ml per acre",
      },
      {
        name: "AGRISTIN",
        type: "Systemic Fungicide",
        active: "CARBENDAZIM 50% WP",
        crops:
          "Paddy, Wheat, Groundnut, Pea, Cotton, Pumpkin, Brinjal, Apple, Grapes, Barley",
        pack: "1Kg, 500gm, 250gm",
        image: "/Products/new/FUNGICIDE/agristin.png",
        emoji: "🌱",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls blast, smut, tikka disease",
          "Systemic absorption and translocation",
          "Effective as seed treatment",
          "Broad spectrum crop protection",
        ],
        dosage: "100-120 GM per acre",
      },
      {
        name: "VALIDATE",
        type: "Biological Fungicide",
        active: "VALIDAMYCIN 3% SL",
        crops: "Paddy",
        pack: "1Ltr, 500ml, 250ml",
        image: "/Products/new/FUNGICIDE/validate.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls sheath blight in paddy",
          "Biological mode of action",
          "No resistance issues",
          "Safe for beneficial organisms",
        ],
        dosage: "400ML per acre",
      },
      {
        name: "AGRIXYL",
        type: "Seed Treatment Fungicide",
        active: "METALAXYL 35% W.S.",
        crops: "Maize, Bajra, Sorghum, Sunflower, Mustard",
        pack: "100GM",
        image: "/Products/new/FUNGICIDE/agrixyl.png",
        emoji: "🌻",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Controls downy mildew diseases",
          "Seed treatment formulation",
          "Protects at early crop stage",
          "2-3g per kg of seed application",
        ],
        dosage: "2-3g per kg of seed",
      },
    ],
  },
  {
    id: "insecticide",
    icon: "🐛",
    color: "#C0392B",
    colorLight: "rgba(192,57,43,0.12)",
    label: "INSECTICIDE",
    heading: "Target Insects. Protect Crops.",
    desc: "Advanced insecticide formulations delivering fast knockdown and lasting residual control against a wide spectrum of damaging insect pests.",
    products: [
      {
        name: "APLHA Plus",
        type: "Synthetic Pyrethroid",
        active: "Alphacypermethrin 10% EC",
        crops: "Paddy, Cotton",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/alpha-plus.png",
        emoji: "⚡",
        color: "#FFF3E0",
        badge: "Best Seller",
        details: [
          "Controls stem borers & leaf folders",
          "Fast knockdown action",
          "30-day residual protection",
          "Safe for beneficial insects",
        ],
        dosage: "70-100 ml per Acre",
      },
      {
        name: "AGRIBAN",
        type: "Organophosphate",
        active: "CHLORPYRIPHOS 20% EC",
        crops:
          "Paddy, Sugarcane, Beans, Cotton, Groundnut, Brinjal, Cabbage, Onion, Apple, BER, Citrus, Tobacco, Grapes",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/agriban.png",
        emoji: "⚡",
        color: "#FFF3E0",
        badge: "Best Seller",
        details: [
          "Controls 40+ insect species",
          "Systemic action within 2 hours",
          "30-day residual protection",
          "Broad spectrum lepidopteran control",
        ],
        dosage: "250-1000 ml per Acre",
      },
      {
        name: "APEX",
        type: "Neonicotinoid",
        active: "ACETAMIPRID 20% SP",
        crops: "Cotton, Cabbage, Okra, Chilli, Paddy",
        pack: "20GM, 100GM",
        image: "/Products/new/INSECTICIDE/apex.png",
        emoji: "⚡",
        color: "#FFEBEE",
        badge: "Best Seller",
        details: [
          "Ultra-fast knockdown on contact",
          "Controls 60+ insect species",
          "Excellent rainfastness after 1hr",
          "Low dose — high field efficacy",
        ],
        dosage: "20-40GM per acre",
      },
      {
        name: "JUST",
        type: "Synthetic Pyrethroid",
        active: "ALPHA CYPERMETHRIN 10% SC",
        crops: "Paddy, Cotton",
        pack: "1LTR, 500ML, 250ML, 100ML, 50ML",
        image: "/Products/new/INSECTICIDE/just.png",
        emoji: "🌾",
        color: "#FFF3E0",
        badge: "New",
        details: [
          "Broad-spectrum contact & stomach action",
          "Controls stem borers & leaf folders",
          "Long residual activity",
          "Cost-effective bulk application",
        ],
        dosage: "70-110 ml per acre",
      },
      {
        name: "JUST SUPER",
        type: "Bio-Insecticide",
        active: "Emamectin Benzoate 1.5% + Fipronil 3.5% SC",
        crops: "Chilli",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/just-super.png",
        emoji: "🍎",
        color: "#FBE9E7",
        badge: "New",
        details: [
          "Derived from natural soil bacterium",
          "Controls thrips, caterpillars & leafminers",
          "IPM and organic compatible",
          "Rapid ingestion & contact activity",
        ],
        dosage: "200-300 ml per acre",
      },
      {
        name: "Fipro-SUPER",
        type: "Systemic Insecticide",
        active: "FIPRONIL 5% SC",
        crops: "Sugarcane, Chilli, Paddy, Cabbage, Cotton",
        pack: "1 LTR, 500 ML, 250 ML & 100 ML",
        image: "/Products/new/INSECTICIDE/fipro-super.png",
        emoji: "🍎",
        color: "#FBE9E7",
        badge: "New",
        details: [
          "Derived from natural soil bacterium",
          "Controls thrips, caterpillars & leafminers",
          "IPM and organic compatible",
          "Rapid ingestion & contact activity",
        ],
        dosage: "300-800 ml per acre",
      },
      {
        name: "LAUNCHER",
        type: "Avermectin / Macrocyclic",
        active: "EMAMECTIN BENZOATE 5% SG",
        crops:
          "Cotton, Okra, Grapes, Brinjal, Chilli, Redgram, Chickpea, Cabbage",
        pack: "1KG, 500GM, 250GM, 100G, 50GM",
        image: "/Products/new/INSECTICIDE/launcher.png",
        emoji: "🌶️",
        color: "#FCE4EC",
        badge: null,
        details: [
          "Highly active against lepidopteran pests",
          "Translaminar penetration",
          "Effective at very low doses",
          "Minimal impact on beneficials",
        ],
        dosage: "80-100 GM per Acre",
      },
      {
        name: "LOOKA",
        type: "Pyrethroid Contact",
        active: "LAMBDA CYHALOTHRIN 4.9% CS",
        crops: "Paddy, Okra, Brinjal, Tamato, Cotton, Chilli",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/looka.png",
        emoji: "🍃",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls all mite life stages",
          "Ovicidal + larvicidal activity",
          "Long residual control (4–6 weeks)",
          "Safe for predatory mites",
        ],
        dosage: "100-200 ml per acre",
      },
      {
        name: "LUCY",
        type: "Diamide Insecticide",
        active: "LAMBDACYHALOTHRIN 5% EC",
        crops:
          "Grapes, Brinjal, Tomato, Cotton, Chilli, Paddy, Okra, Tobacco, Mango",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/lucy.png",
        emoji: "🫘",
        color: "#F3E5F5",
        badge: null,
        details: [
          "Novel ryanodine receptor target",
          "Controls resistant caterpillar populations",
          "Long residual field protection",
          "No cross-resistance with pyrethroids",
        ],
        dosage: "100-120 ml per acre",
      },
      {
        name: "MARIO",
        type: "Combination Insecticide",
        active: "Emamectin Benzoate 3.0% + Thiamethoxam 12.0% WG",
        crops:
          "Cotton, Okra, Redgram, Chickpea, Brinjal, Chilli, Cabbage, Grapes",
        pack: "500GM, 250GM, 100G",
        image: "/Products/new/INSECTICIDE/mario.png",
        emoji: "🌿",
        color: "#F3E5F5",
        badge: null,
        details: [
          "Novel ryanodine receptor target",
          "Controls resistant caterpillar populations",
          "Long residual field protection",
          "No cross-resistance with pyrethroids",
        ],
        dosage: "88-100 GM per acre",
      },
      {
        name: "RYNO SUPER",
        type: "Seed Treatment",
        active: "THIAMETHOXAM 30% FS",
        crops: "Cotton, Okra, Wheat, Chilli, Maize, Soybean, Sorghum",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML",
        image: "/Products/new/INSECTICIDE/ryno-super.png",
        emoji: "🌱",
        color: "#F3E5F5",
        badge: null,
        details: ["NOTE: IT IS RECOMMENDED FOR SEED TREATMENT ONLY"],
        dosage: "8-10 ML per kg of seed",
      },
      {
        name: "RYNO",
        type: "Neonicotinoid",
        active: "THIAMETHOXAM 25% WG",
        crops:
          "Cotton, Okra, Wheat, Chilli, Maize, Soybean, Sorghum, Paddy, Mango, Mustard, Brinjal, Citrus, Tea",
        pack: "1KG, 500GM, 250GM, 100GM, 50GM",
        image: "/Products/new/INSECTICIDE/ryno.png",
        emoji: "🫘",
        color: "#F3E5F5",
        badge: null,
        details: [
          "Systemic translocation to all plant parts",
          "Controls sucking and chewing pests",
          "Long residual field protection",
          "No cross-resistance with pyrethroids",
        ],
        dosage: "40-80 GM per acre",
      },
      {
        name: "AGRIKILL-25",
        type: "Synthetic Pyrethroid",
        active: "Cypermethrin 25% EC",
        crops: "Cotton, Sugarcane, Cabbage, Okra, Brinjal, Sunflower",
        pack: "1Ltr, 500ml, 250ml",
        image: "/Products/new/INSECTICIDE/agrikill-25.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Ultra-fast knockdown on contact",
          "Controls bollworms, jassids & thrips",
          "Excellent rainfastness",
          "Low dose — high field efficacy",
        ],
        dosage: "60-120 ml Per Acre",
      },
      {
        name: "LARBA-505",
        type: "Combination Insecticide",
        active: "CHLORPYRIPHOS 50% + CYPERMETHRIN 5% EC",
        crops: "Paddy, Cotton",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML",
        image: "/Products/new/INSECTICIDE/larba-505.png",
        emoji: "⚡",
        color: "#FFF3E0",
        badge: "Best Seller",
        details: [
          "Dual mode of action contact and systemic",
          "Controls stem borers and leaf folders",
          "Controls aphids, jassids and bollworms",
          "Long residual activity",
        ],
        dosage: "300-500 ML per acre",
      },
      {
        name: "ALITE",
        type: "Combination Insecticide",
        active: "THIAMETHOXAM 12.6% + LAMBDA CYHALOTHRIN 9.5% ZC",
        crops: "Cotton, Tea, Tomato, Maize, Chilli, Groundnut, Soybean",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML, 20ML",
        image: "/Products/new/INSECTICIDE/alite.png",
        emoji: "⚡",
        color: "#FFF3E0",
        badge: "New",
        details: [
          "Dual systemic and contact action",
          "Controls aphids, jassids, thrips & bollworms",
          "Fast knockdown with long residual",
          "Compatible with most fungicides",
        ],
        dosage: "50-80 ML per acre",
      },
      {
        name: "AGRIDOX",
        type: "Oxadiazine Insecticide",
        active: "INDOXACARB 14.5% SC",
        crops: "Cotton, Tomato, Pigeon Pea, Cabbage, Chilli",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/agridox.png",
        emoji: "🌶️",
        color: "#FCE4EC",
        badge: null,
        details: [
          "Controls bollworms and pod borers",
          "Novel sodium channel blocker",
          "Low toxicity to beneficial insects",
          "Fast knockdown with residual activity",
        ],
        dosage: "200ML per acre",
      },
      {
        name: "MARIO GOLD",
        type: "Emamectin Insecticide",
        active: "EMAMECTIN BENZOATE 1.9% EC",
        crops: "Cotton",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/mario-gold.png",
        emoji: "🌿",
        color: "#F3E5F5",
        badge: null,
        details: [
          "Controls bollworms and caterpillars",
          "Translaminar penetration",
          "Effective at very low doses",
          "Minimal impact on beneficial insects",
        ],
        dosage: "200 ML per acre",
      },
      {
        name: "CORAMECK-GR",
        type: "Diamide Granule",
        active: "CHLORANTRANILIPROLE 0.4% W/W GR",
        crops: "Paddy, Sugarcane",
        pack: "5 KG",
        image: "/Products/new/INSECTICIDE/corameck-gr.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls shoot borer, stem borer & whorl maggot",
          "Granule formulation for easy application",
          "Long residual soil activity",
          "Selective for target pests",
        ],
        dosage: "4-8 KG per acre",
      },
      {
        name: "VICTORY",
        type: "Neonicotinoid",
        active: "IMIDACLOPRID 70% WG",
        crops: "Cotton, Okra, Paddy, Cucumber",
        pack: "300GM, 150GM, 75GM, 30GM, 2GM",
        image: "/Products/new/INSECTICIDE/victory.png",
        emoji: "⚡",
        color: "#FFEBEE",
        badge: null,
        details: [
          "Controls aphids, jassids, thrips & BPH",
          "Systemic translocation within plant",
          "Water dispersible granule formulation",
          "Long residual systemic action",
        ],
        dosage: "12-30 GM per acre",
      },
      {
        name: "PRO-X SUPER",
        type: "Combination Insecticide",
        active: "PROFENOFOS 40%+CYPERMETHRIN 4% EC",
        crops: "Cotton",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/pro-x-super.png",
        emoji: "⚡",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls bollworm complex",
          "Dual contact and stomach action",
          "Broad spectrum pest control",
          "Fast knockdown with residual protection",
        ],
        dosage: "400-600 ML per acre",
      },
      {
        name: "PUNCH",
        type: "Systemic Insecticide",
        active: "FIPRONIL 40% + IMIDACLOPRID 40% WG",
        crops: "Sugarcane",
        pack: "100GM, 10GM",
        image: "/Products/new/INSECTICIDE/punch.png",
        emoji: "🌾",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls white grubs in sugarcane",
          "Dual active ingredient formulation",
          "Soil application for soil pests",
          "Long residual activity in soil",
        ],
        dosage: "175-200 GM per acre",
      },
      {
        name: "AGRITAP-4G",
        type: "Granule Insecticide",
        active: "CARTAP HYDROCHLORIDE 4% GR",
        crops: "Paddy",
        pack: "5 KG",
        image: "/Products/new/INSECTICIDE/agritap-4g.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls stem borer, leaf folder & whorl maggot",
          "Granule formulation — easy broadcast",
          "Long residual soil activity",
          "Selective control for paddy pests",
        ],
        dosage: "5-10 KG per acre",
      },
      {
        name: "FIPRO ULTRA",
        type: "Phenylpyrazole Granule",
        active: "FIPRONIL 0.6% GR",
        crops: "Sugarcane, Paddy, Wheat",
        pack: "4 KG, 1 KG",
        image: "/Products/new/INSECTICIDE/fipro-ultra.png",
        emoji: "🌾",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls root borer, stem borer & GLH",
          "Granule formulation for soil application",
          "Long residual activity",
          "Effective on termites in wheat",
        ],
        dosage: "1-8 KG per acre",
      },
      {
        name: "FIPRO GR",
        type: "Phenylpyrazole Granule",
        active: "FIPRONIL 0.3% GR",
        crops: "Sugarcane, Paddy, Wheat",
        pack: "5 KG, 1 KG",
        image: "/Products/new/INSECTICIDE/fipro-gr.png",
        emoji: "🌾",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls root borer and early shoot borer",
          "Granule soil application",
          "Residual activity for long season protection",
          "Effective on termites and WBPH",
        ],
        dosage: "5-13 KG per acre",
      },
      {
        name: "PUBG",
        type: "Systemic Insecticide",
        active: "PYMETROZINE 50% WG",
        crops: "Cotton, Sugarcane, Chilli, Paddy, Cabbage",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/pubg.png",
        emoji: "🍃",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls sucking pests — aphids, jassids & BPH",
          "Systemic and translaminar activity",
          "Novel mode of action — resistance management",
          "Low toxicity to beneficial insects",
        ],
        dosage: "120 GM per acre",
      },
      {
        name: "CORAMECK",
        type: "Diamide Insecticide",
        active: "CHLORANTRANILIPROLE 18.5% W/W SC",
        crops: "Paddy, Sugarcane",
        pack: "600ml, 300ml, 150ml, 60ml, 30ml, 10ml",
        image: "/Products/new/INSECTICIDE/corameck.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls stem borer and top borer",
          "Excellent systemic activity",
          "Long residual protection",
          "Compatible with most pesticides",
        ],
        dosage: "60-150 ML per acre",
      },
      {
        name: "DESTROYER",
        type: "Combination Insecticide",
        active: "DINOTEFURAN 15% + PYMETROZINE 45% WG",
        crops: "Paddy",
        pack: "132.2gm, 333gm, 666gm",
        image: "/Products/new/INSECTICIDE/destroyer.png",
        emoji: "⚡",
        color: "#FFEBEE",
        badge: null,
        details: [
          "Controls brown plant hopper and WBPH",
          "Green leaf hopper and rice ear head bug control",
          "Dual mode of action",
          "Fast knockdown with residual protection",
        ],
        dosage: "133.2 GM per acre",
      },
      {
        name: "VARDAN SP",
        type: "Organochlorine",
        active: "CARTAP HYDROCHLORIDE 50% SP",
        crops: "Paddy",
        pack: "500GM, 250GM, 100GM, 50GM",
        image: "/Products/new/INSECTICIDE/vardan-sp.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls stem borer and leaf folder",
          "Broad spectrum insecticidal activity",
          "Water soluble powder formulation",
          "Long residual activity",
        ],
        dosage: "250-400 GM per acre",
      },
      {
        name: "AGRIDON",
        type: "Systemic Granule",
        active: "CARBOFURAN 3% CG (Encapsulated)",
        crops:
          "Bajra, Maize, Paddy, Groundnut, Sugarcane, Tomato, Chillies, Apple, Citrus",
        pack: "5 Kg, 1Kg",
        image: "/Products/new/INSECTICIDE/agridon.png",
        emoji: "🌱",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls shoot fly, stem borer & leaf hopper",
          "Encapsulated for extended release",
          "Systemic uptake via roots",
          "Effective against soil and foliar pests",
        ],
        dosage: "10-20 KG per acre",
      },
      {
        name: "NO FLY",
        type: "Bio Insecticide",
        active: "BIO INSECTICIDE",
        crops: "All Crops",
        pack: "50GM, 20GM, 10GM",
        image: "/Products/new/INSECTICIDE/no-fly.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls sucking pests biologically",
          "Safe for beneficial insects",
          "Compatible with IPM programs",
          "No resistance issues",
        ],
        dosage: "10GM per 15 LTR water",
      },
      {
        name: "APPLE",
        type: "Combination Insecticide",
        active: "CHLORANTRANILIPROLE 9.3%+LAMBDACYHALOTHRIN 4.6% ZC",
        crops:
          "Cotton, Brinjal, Okra, Paddy, Soybean, Cabbage, Groundnut, Blackgram",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/apple.png",
        emoji: "🍎",
        color: "#FBE9E7",
        badge: "New",
        details: [
          "Dual systemic and contact action",
          "Controls bollworms complex and stem borers",
          "Fast knockdown with long residual",
          "Broad spectrum pest control",
        ],
        dosage: "80-100 ml per acre",
      },
      {
        name: "ROYAL CHILLI",
        type: "Bio Miticide",
        active: "BIO MITICIDE",
        crops: "All Crops",
        pack: "100ML, 50ML, 20ML",
        image: "/Products/new/INSECTICIDE/royal-chilli.png",
        emoji: "🌶️",
        color: "#FCE4EC",
        badge: null,
        details: [
          "Controls thrips and mites biologically",
          "Safe for beneficial insects",
          "IPM and organic compatible",
          "Rapid ingestion & contact activity",
        ],
        dosage: "20ML per 15 LTR water",
      },
      {
        name: "AGTHRIN",
        type: "Synthetic Pyrethroid",
        active: "BIFENTHRIN 10% EC",
        crops: "Cotton, Sugarcane, Paddy",
        pack: "1Ltr, 500ml, 250ml",
        image: "/Products/new/INSECTICIDE/agthrin.png",
        emoji: "⚡",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls bollworm, white fly, termites & stem borer",
          "Fast knockdown on contact",
          "Long residual activity",
          "Broad spectrum pest control",
        ],
        dosage: "320-400 ML per acre",
      },
      {
        name: "ALPHA GOLD",
        type: "Synthetic Pyrethroid",
        active: "ALPHACYPERMETHRIN 10% EC",
        crops: "Cotton",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/alpha-gold.png",
        emoji: "⚡",
        color: "#FFEBEE",
        badge: null,
        details: [
          "Controls bollworms in cotton",
          "Fast knockdown on contact",
          "30-day residual protection",
          "Low dose — high field efficacy",
        ],
        dosage: "115 ml per acre",
      },
      {
        name: "DENTU",
        type: "Systemic Insecticide",
        active: "DINOTEFURAN 20% W/W SG",
        crops: "Cotton, Paddy",
        pack: "1KG, 500GM, 250GM",
        image: "/Products/new/INSECTICIDE/dentu.png",
        emoji: "🍃",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls aphids, jassids, thrips & BPH",
          "Systemic and translaminar activity",
          "Fast acting with residual control",
          "Novel mode of action",
        ],
        dosage: "150-200 GM per acre",
      },
      {
        name: "DRON",
        type: "Organochlorine",
        active: "CARTAP HYDROCHLORIDE 75% SG",
        crops: "Rice",
        pack: "1KG, 500GM, 250GM, 100GM",
        image: "/Products/new/INSECTICIDE/dron.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls yellow stem borer and leaf folder",
          "Water dispersible granule formulation",
          "Systemic absorption and translocation",
          "Long residual activity",
        ],
        dosage: "170-200 GM per acre",
      },
      {
        name: "PATAKA",
        type: "Combination Granule",
        active: "THIAMETHOXAM 1.0% + CHLORANTRANILIPROLE 0.5% GR",
        crops: "Maize, Paddy, Sugarcane",
        pack: "5KG, 2.5KG",
        image: "/Products/new/INSECTICIDE/pataka.png",
        emoji: "🌽",
        color: "#FFF3E0",
        badge: "New",
        details: [
          "Dual action against sucking and chewing pests",
          "Controls aphid, stem borer & brown plant hopper",
          "Granule formulation for soil application",
          "Slow release for season-long protection",
        ],
        dosage: "2.5-4 KG per acre",
      },
      {
        name: "MARO",
        type: "Combination Insecticide",
        active: "NOVALURON 5.25%+EMAMECTIN BENZOATE 0.9% SC",
        crops: "Chilli, Red Gram, Rice",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/INSECTICIDE/maro.png",
        emoji: "🌶️",
        color: "#FCE4EC",
        badge: null,
        details: [
          "Controls gram pod borers & tobacco caterpillars",
          "Dual mode of action — IGR + Avermectin",
          "Translaminar penetration",
          "Low toxicity to beneficial insects",
        ],
        dosage: "350 ml per acre",
      },
      {
        name: "CORAMACK SUPER",
        type: "Diamide Seed Treatment",
        active: "CHLORANTRANILIPROLE 50% W/W FS",
        crops: "Rice",
        pack: "100ml, 50ml",
        image: "/Products/new/INSECTICIDE/coramack-super.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Seed treatment for rice water weevil",
          "Controls Chironomidae larvae",
          "Applied at 80-100ml per 100kg seed",
          "Max 64 ml/Acre application rate",
        ],
        dosage: "80-100ML per 100kg seed",
      },
      {
        name: "SYNDICATE",
        type: "Carbamate Insecticide",
        active: "FENOBUCARB (B.P.M.C.) 50% EC",
        crops: "Rice",
        pack: "1Ltr, 500ml, 250ml",
        image: "/Products/new/INSECTICIDE/syndicate.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls brown plant hopper & green leaf hopper",
          "Contact and systemic action",
          "Effective against sucking pests in rice",
          "Compatible with most fungicides",
        ],
        dosage: "300-500 ML per acre",
      },
      {
        name: "RACER",
        type: "Diamide Insecticide",
        active: "CHLORANTRANILIPROLE 18.5% W/W SC",
        crops: "Paddy, Sugarcane",
        pack: "600ml, 300ml, 150ml, 60ml, 30ml, 10ml",
        image: "/Products/new/INSECTICIDE/racer.png",
        emoji: "🍚",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Controls stem borer in paddy",
          "Controls early shoot borer & top borer in sugarcane",
          "Long residual activity",
          "Excellent systemic action",
        ],
        dosage: "60-150 ML per acre",
      },
      {
        name: "RANGER",
        type: "Organophosphate",
        active: "DIMETHOATE 30% EC",
        crops: "Cabbage, Okra, Banana, Brinjal, Potato, Apple",
        pack: "1Ltr, 500ml",
        image: "/Products/new/INSECTICIDE/ranger.png",
        emoji: "🍃",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Controls aphids, mustard aphids & painted bug",
          "Effective on jassid and stem borer",
          "Systemic and contact action",
          "Broad spectrum pest control",
        ],
        dosage: "1-2 ml per 1L of water",
      },
      {
        name: "TEEKA",
        type: "Combination Insecticide",
        active: "CYANTRANILIPROLE 19.8%+THIAMETHOXAM 19.8% FS",
        crops: "Maize, Corn",
        pack: "100ML, 50ML",
        image: "/Products/new/INSECTICIDE/teeka.png",
        emoji: "🌽",
        color: "#FFF3E0",
        badge: "New",
        details: [
          "Controls fall armyworm (Spodoptera frugiperda)",
          "Controls shoot fly, stem borer & aphids",
          "Soil pest control — cutworms & termites",
          "Dual active ingredient — resistance management",
        ],
        dosage: "32 ml per acre",
      },
    ],
  },
  {
    id: "pgr",
    icon: "🌱",
    color: "#0288D1",
    colorLight: "rgba(2,136,209,0.12)",
    label: "PGR",
    heading: "Regulate Growth. Maximise Yield.",
    desc: "Plant growth regulators that precisely control vegetative and reproductive development — improving stem strength, fruit set, and overall crop architecture.",
    products: [
      {
        name: "Hike Plus",
        type: "Growth Retardant",
        active: "GIBBERELLIC ACID 0.001% L",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/PGR/hikeplus.png",
        emoji: "🌾",
        color: "#E1F5FE",
        badge: "Best Seller",
        details: [
          "Reduces lodging by shortening internodes",
          "Improves stem strength & anchorage",
          "Increases tiller production",
          "Compatible with most fungicides",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "YOSHI",
        type: "Rooting Hormone",
        active: "GIBBERELLIC ACID 0.001% L",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/PGR/yoshi.png",
        emoji: "🌱",
        color: "#E1F5FE",
        badge: null,
        details: [
          "Stimulates adventitious root formation",
          "Improves cutting strike rates",
          "Fast establishment in nursery",
          "Safe for all propagation types",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "ROYAL NITRO",
        type: "Biostimulant",
        active: "GIBBERELLIC ACID 0.001% L",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/PGR/royal-nitro.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Boosts photosynthesis & enzyme activity",
          "Improves nutrient uptake efficiency",
          "Increases crop vigour & yield",
          "Fully compatible with fertilisers",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "TRIKULAN",
        type: "PGR Biostimulant",
        active: "TRIACONTANOL EW 0.1% EW",
        crops: "ALL CROPS",
        pack: "1 LTR, 500 ML, 250 ML, 100 ML",
        image: "/Products/new/PGR/trikulan.png",
        emoji: "🍅",
        color: "#FBE9E7",
        badge: null,
        details: [
          "Accelerates uniform fruit ripening",
          "Promotes boll opening in cotton",
          "Reduces green fruit at harvest",
          "Easy foliar application",
        ],
        dosage: "100-150ML PER ACRE",
      },
      {
        name: "VARDAAN",
        type: "Humic Acid",
        active: "HUMIC ACID 98%",
        crops: "ALL CROPS",
        pack: "500GM, 100GM",
        image: "/Products/new/PGR/vardaan.png",
        emoji: "🍇",
        color: "#EDE7F6",
        badge: "Best Seller",
        details: [
          "Promotes fruit set & berry sizing",
          "Reduces fruit drop",
          "Stimulates lateral bud break",
          "Improves cluster uniformity",
        ],
        dosage: "600-1200GM per acre",
      },
      {
        name: "RAIZOSTAR",
        type: "PGR Granule",
        active: "TRIANCONTANOL 0.05% GR",
        crops: "Wheat, Paddy, Vegetables, Chilli, Cotton, Groundnut",
        pack: "4KG, 1KG",
        image: "/Products/new/PGR/raizostar.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Elongates internodes & berry clusters",
          "Breaks dormancy in seeds & buds",
          "Improves seedless grape berry size",
          "Low dose — highly active",
        ],
        dosage: "10KG per acre",
      },
      {
        name: "RAIZOSTAR",
        type: "PGR Granule 12KG",
        active: "TRIANCONTANOL 0.05% GR",
        crops: "Wheat, Paddy, Vegetables, Chilli, Cotton, Groundnut",
        pack: "12KG",
        image: "/Products/new/PGR/raizo-star.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Elongates internodes & berry clusters",
          "Breaks dormancy in seeds & buds",
          "Improves seedless grape berry size",
          "Low dose — highly active",
        ],
        dosage: "10KG per acre",
      },
      {
        name: "SIFAT",
        type: "PGR Granule 12KG",
        active: "TRIANCONTANOL 0.05% GR",
        crops: "Wheat, Paddy, Vegetables, Cotton, Groundnut",
        pack: "12KG",
        image: "/Products/new/PGR/sifat.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Elongates internodes & berry clusters",
          "Breaks dormancy in seeds & buds",
          "Improves seedless grape berry size",
          "Low dose — highly active",
        ],
        dosage: "10KG per acre",
      },
      {
        name: "SIFAT",
        type: "PGR Granule 3KG",
        active: "TRIANCONTANOL 0.05% GR",
        crops: "Wheat, Paddy, Vegetables, Cotton, Groundnut",
        pack: "3KG",
        image: "/Products/new/PGR/sifat1.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Elongates internodes & berry clusters",
          "Breaks dormancy in seeds & buds",
          "Improves seedless grape berry size",
          "Low dose — highly active",
        ],
        dosage: "10KG per acre",
      },
      {
        name: "4G POWER",
        type: "Gibberellin PGR",
        active: "GIBBERELLIC ACID 0.001% L",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/PGR/4g-power.png",
        emoji: "🌱",
        color: "#E1F5FE",
        badge: null,
        details: [
          "Boosts photosynthesis & enzyme activity",
          "Improves nutrient uptake efficiency",
          "Increases crop vigour & yield",
          "Fully compatible with fertilisers",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "AGRIGIB",
        type: "Gibberellin",
        active: "GIBBERELLIC ACID 40% WSG",
        crops: "ALL CROP",
        pack: "1GM",
        image: "/Products/new/PGR/agrigib.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Boosts photosynthesis & enzyme activity",
          "Improves nutrient uptake efficiency",
          "Increases crop vigour & yield",
          "Fully compatible with fertilisers",
        ],
        dosage: "1-2GM Per Acre",
      },
      {
        name: "PUSHPAK",
        type: "Gibberellin",
        active: "GIBBERELLIC ACID 0.001% L",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1 LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/PGR/pushpak.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Boosts photosynthesis & enzyme activity",
          "Improves nutrient uptake efficiency",
          "Increases crop vigour & yield",
          "Fully compatible with fertilisers",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "AGRIBIT",
        type: "Silicon Spreader",
        active: "SILICON BASED SPREADER",
        crops: "All Crops",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML, 10ML",
        image: "/Products/new/PGR/agribit.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Improves pesticide coverage & uptake",
          "Reduces surface tension for better spread",
          "Compatible with all spray formulations",
          "Increases efficacy of foliar sprays",
        ],
        dosage: "5ML PER 15 LTR. WATER",
      },
      {
        name: "RAIN+",
        type: "Silicon Spreader",
        active: "SILICON BASED SPREADER",
        crops: "All Crops",
        pack: "1 LTR, 500ML, 250ML, 100ML, 50ML",
        image: "/Products/new/PGR/rain-plus.png",
        emoji: "🌧️",
        color: "#E1F5FE",
        badge: null,
        details: [
          "Improves pesticide coverage & uptake",
          "Reduces surface tension for better spread",
          "Compatible with all spray formulations",
          "Increases efficacy of foliar sprays",
        ],
        dosage: "5ML PER 15 LTR WATER",
      },
      {
        name: "RE-ENTRY",
        type: "Crop Stimulant",
        active: "CROP STIMULANT",
        crops: "All Crops",
        pack: "100ML, 50ML, 10ML",
        image: "/Products/new/PGR/re-entry.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Boosts photosynthesis & enzyme activity",
          "Improves nutrient uptake efficiency",
          "Increases crop vigour & yield",
          "Fully compatible with fertilisers",
        ],
        dosage: "5ML PER 15 LTR WATER",
      },
      {
        name: "AGREE SUPER POWER",
        type: "Gibberellin PGR",
        active: "GIBBERELLIC ACID 0.001% L",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1LTR, 500ML, 250ML, 100ML",
        image: "/Products/new/PGR/agree-super-power.png",
        emoji: "⚡",
        color: "#E1F5FE",
        badge: null,
        details: [
          "Boosts crop growth and development",
          "Improves nutrient uptake efficiency",
          "Increases crop vigour & yield",
          "Fully compatible with fertilisers",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "CLUSTER",
        type: "Growth Retardant",
        active: "PACLOBTURAZOLE 23% SC",
        crops:
          "Grapes, Cotton, Banana, Sugarcane, Cabbage, Cauliflower, Paddy, Onion, Brinjal, Okra, Mulberry, Groundnut",
        pack: "1LTR, 500ML, 250ML, 100ML, 50ML",
        image: "/Products/new/PGR/cluster.png",
        emoji: "🍇",
        color: "#EDE7F6",
        badge: null,
        details: [
          "Reduces vegetative growth",
          "Promotes flower initiation & fruit set",
          "Improves fruit quality and shelf life",
          "Selective growth retardant action",
        ],
        dosage: "1-2.5ML PER LTR WATER",
      },
      {
        name: "AGRIPHON",
        type: "Ethylene Releaser",
        active: "Ethephone 39% S.L.",
        crops: "All Crops",
        pack: "1 LTR, 500 ML, 250 ML, 100 ML",
        image: "/Products/new/PGR/agriphon.png",
        emoji: "🍅",
        color: "#FBE9E7",
        badge: null,
        details: [
          "Improves crop shape with fruit elongation",
          "Promotes uniform fruit development",
          "Accelerates ripening",
          "Easy foliar application",
        ],
        dosage: "100-150ML per acre",
      },
      {
        name: "BACTIMAR",
        type: "Antibacterial",
        active: "2-BROMO-2-NITROPROPANE",
        crops: "All Crops",
        pack: "20GM",
        image: "/Products/new/PGR/bactimar.png",
        emoji: "☀️",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Broad spectrum antibacterial activity",
          "Controls bacterial diseases",
          "Improves crop health",
          "Compatible with most pesticides",
        ],
        dosage: "20GM Per Acre",
      },
      {
        name: "BHAG BHAI BHAG",
        type: "Animal Repellent",
        active: "TAKE A SHARE DRIVE AWAY THE PIG",
        crops: "Wheat, Paddy, Vegetables, Cotton, Groundnut",
        pack: "1Kg",
        image: "/Products/new/PGR/bhag-bhai-bhag.png",
        emoji: "🐗",
        color: "#FFF3E0",
        badge: null,
        details: [
          "Drives away pigs from fields",
          "Protects crops from animal damage",
          "Natural repellent formulation",
          "Easy granule application",
        ],
        dosage: "10 KG per acre",
      },
      {
        name: "TRIKULAN GR",
        type: "PGR Granule",
        active: "TRIANCONTANOL 0.05% GR",
        crops: "Wheat, Paddy, Vegetables, Cotton, Groundnut",
        pack: "40KG, 5KG",
        image: "/Products/new/PGR/trikulan-gr.png",
        emoji: "🌿",
        color: "#E8F5E9",
        badge: null,
        details: [
          "Elongates internodes & berry clusters",
          "Breaks dormancy in seeds & buds",
          "Improves crop vigour and yield",
          "Low dose — highly active",
        ],
        dosage: "10KG per acre",
      },
      {
        name: "ASPIRE GOLD",
        type: "Humic + Fulvic Acid",
        active: "HUMIC ACID + FULVIC ACID",
        crops: "All Crops",
        pack: "500GM",
        image: "/Products/new/PGR/aspire-gold.png",
        emoji: "🌟",
        color: "#FFFDE7",
        badge: null,
        details: [
          "Increases growth & cell division",
          "Improves nutrient uptake efficiency",
          "Enhances root development",
          "Boosts overall plant immunity",
        ],
        dosage: "600-1200GM per acre",
      },
    ],
  },
];

export const solutions = [
  {
    icon: "🌾",
    title: "Row Crop Protection",
    desc: "Complete programs for wheat, corn, soybean and rice covering pre-plant to post-harvest.",
  },
  {
    icon: "🍅",
    title: "Vegetable Solutions",
    desc: "Targeted formulations protecting high-value vegetable crops against pests, weeds and disease.",
  },
  {
    icon: "🍇",
    title: "Orchard & Vineyard",
    desc: "Specialised chemistry for fruits and grapes with residue management and harvest interval guidance.",
  },
  {
    icon: "🌴",
    title: "Plantation Crops",
    desc: "Scalable solutions for sugarcane, cotton, tea and coffee with bulk supply programs.",
  },
  {
    icon: "🌱",
    title: "Seed Treatment",
    desc: "Protective seed treatments that give crops a healthy, pest-free start from germination.",
  },
  {
    icon: "🧪",
    title: "Custom Formulation",
    desc: "Our R&D team develops custom active ingredient combinations for specific regional challenges.",
  },
];

export const scienceSteps = [
  {
    num: "01",
    icon: "🔬",
    title: "Discovery & Screening",
    desc: "Thousands of molecules screened annually using AI-assisted modelling and biological assays.",
  },
  {
    num: "02",
    icon: "🧬",
    title: "Active Ingredient R&D",
    desc: "Multi-year efficacy and selectivity studies confirming performance across diverse crop systems.",
  },
  {
    num: "03",
    icon: "⚗️",
    title: "Formulation Science",
    desc: "Advanced formulation technology — SC, WG, EC, OD — optimised for uptake and rainfastness.",
  },
  {
    num: "04",
    icon: "✅",
    title: "Regulatory & Safety",
    desc: "Rigorous global registration with full environmental fate, toxicology and residue data packages.",
  },
];

export const crops = [
  { emoji: "🌾", name: "Wheat" },
  { emoji: "🌽", name: "Corn" },
  { emoji: "🫘", name: "Soybean" },
  { emoji: "🍚", name: "Rice" },
  { emoji: "🍅", name: "Tomato" },
  { emoji: "🥔", name: "Potato" },
  { emoji: "🍇", name: "Grapes" },
  { emoji: "🍎", name: "Apple" },
  { emoji: "🧅", name: "Onion" },
  { emoji: "🥦", name: "Brassica" },
  { emoji: "☕", name: "Coffee" },
  { emoji: "🌴", name: "Sugarcane" },
];

export const testimonials = [
  {
    text: "DAMINI GOLD ka istemal karne ke baad hamare paddy ke khet mein kharpatwar bilkul khatam ho gaya. Pehle hume 3 baar spray karna padta tha, ab ek hi spray mein kaam ho jaata hai. Is saal fasal bhi bahut achhi hui.",
    name: "Ramesh Yadav",
    role: "Paddy Farmer, Gorakhpur, UP",
    avatar: "👨‍🌾",
    stars: 5,
  },
  {
    text: "Maine CUMIN-80 apne angoor ke baag mein use kiya powdery mildew ke liye. Sirf 10 din mein rog ka asar khatam ho gaya. AgreezAgro ke products pe mujhe poora bharosa hai, har season use karta hoon.",
    name: "Suresh Patil",
    role: "Grape Grower, Nashik, Maharashtra",
    avatar: "👨‍🌾",
    stars: 5,
  },
  {
    text: "LAUNCHER se hamari cotton ki fasal mein American bollworm ka problem bilkul solve ho gaya. Dose bhi kam lagta hai aur asar zyada hota hai. Hamare gaon ke sabhi kisan ab yahi use karte hain.",
    name: "Bhavna Ben Patel",
    role: "Cotton Farmer, Surat, Gujarat",
    avatar: "👩‍🌾",
    stars: 5,
  },
  {
    text: "Hike Plus use karne ke baad meri sugarcane ki growth mein bahut farak aaya. Tillering zyada hui aur stem bhi strong raha. AgreezAgro ki team ne timing aur dose mein bahut help ki.",
    name: "Gurpreet Singh",
    role: "Sugarcane Grower, Ludhiana, Punjab",
    avatar: "👨‍🌾",
    stars: 5,
  },
  {
    text: "AGREEZ 71 ne hamare tea garden ke weeds ko poori tarah khatam kar diya bina fasal ko nuksan pahunchaye. Pehle labour pe bahut paisa kharch hota tha, ab us kharche mein kafi bachat ho rahi hai.",
    name: "Priya Devi Sharma",
    role: "Tea Garden Owner, Jorhat, Assam",
    avatar: "👩‍🌾",
    stars: 5,
  },
  {
    text: "METALIX ne meri potato aur grapes dono ko late blight se bachaya. Pichle saal bahut nuksaan hua tha, is saal sahi time pe spray kiya toh fasal ekdum safed rahi. Bahut acha product hai.",
    name: "Manoj Kumar Verma",
    role: "Potato & Grape Farmer, Agra, UP",
    avatar: "🧑‍🌾",
    stars: 5,
  },
];

export const footerLinks = {
  Products: [
    { label: "Herbicides", id: "herbicide" },
    { label: "Fungicides", id: "fungicide" },
    { label: "Insecticide", id: "insecticide" },
    { label: "PGR", id: "pgr" },
  ],
  Solutions: [
    { label: "Row Crops", href: "#solutions" },
    { label: "Vegetables", href: "#solutions" },
    { label: "Orchards", href: "#solutions" },
    { label: "Plantation", href: "#solutions" },
    { label: "Custom Programs", href: "#solutions" },
  ],
  Company: [
    { label: "About Us", href: "#about" },
    { label: "R&D", href: "#science" },
    { label: "Sustainability", href: null },
    { label: "Careers", href: null },
    { label: "Investors", href: null },
  ],
  Support: [
    { label: brand.email, href: `mailto:${brand.email}` },
    { label: brand.phone, href: `tel:${brand.phone}` },
    { label: "Find a Dealer", href: "#contact" },
    { label: "Safety Data Sheets", href: null },
    { label: "Label Downloads", href: null },
  ],
};
